<div class="gag">
  <div class="gag__icon" aria-hidden="true">
    <mat-icon>volunteer_activism</mat-icon>
  </div>
  <h2 mat-dialog-title class="gag__title">We appreciate your enthusiasm</h2>
  <div mat-dialog-content class="gag__body">
    <p>
      Sorry! Gage doesn’t have an OnlyFans. There isn't a big enough market for that. 
    </p>
    <p class="gag__hint">If you’re still interested, consider taking him out to dinner instead first.</p>
  </div>
  <div mat-dialog-actions align="end" class="gag__actions">
    <button mat-flat-button color="primary" type="button" (click)="close()">Fair enough</button>
  </div>
</div>
